import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';
import SpinnerCircles from '../../../Spinner/SpinerCircles';

const E911ReassignModal = ({
  isOpen,
  value,
  options,
  newlyAddedNumber,
  saving,
  onChange,
  onConfirm,
  onCancel,
}) => (
  <Modal isOpen={isOpen} centered backdrop="static" keyboard={false} zIndex={2000}>
    <ModalHeader>Update E911 Number Assignment</ModalHeader>
    <ModalBody>
      <p>
        The phone number currently associated with E911 is being replaced. Select the newly added
        number or another eligible number for E911.
      </p>
      <FormGroup>
        <Label for="e911ReassignNumber">E911 Number</Label>
        <Input
          type="select"
          id="e911ReassignNumber"
          value={value}
          onChange={e => onChange(e.target.value)}
        >
          <option value="">Select a number</option>
          {options.map(item => (
            <option key={item.number} value={item.number}>
              {item.number}
              {newlyAddedNumber === item.number ? ' (newly added)' : ''}
            </option>
          ))}
        </Input>
      </FormGroup>
    </ModalBody>
    <ModalFooter>
      <Button outline color="secondary" onClick={onCancel} disabled={saving}>
        Cancel
      </Button>
      <Button color="primary" onClick={onConfirm} disabled={saving || !value}>
        {saving ? <SpinnerCircles /> : 'Update E911'}
      </Button>
    </ModalFooter>
  </Modal>
);

export default E911ReassignModal;
